import { Link } from "react-router-dom";
import { CalendarDays, SquarePen } from "lucide-react";

const OverviewHeader = ({ currentMonth = "May 2026" }) => {
  return (
    <div className="flex ">
      {/* Left Image */}
      {/* <div className="h-28 w-36 overflow-hidden  shadow-lg">
        <img
          src="/SchoolImage.png"
          alt="school"
          className="h-full w-full object-cover"
        />
      </div> */}

      {/* Right Content */}
      <div className="relative flex-1 overflow-hidden rounded-r-2xl bg-gradient-to-r from-violet-600 via-purple-600 to-indigo-600 p-6 text-white shadow-lg">
        {/* Background Glow */}
        <div className="absolute right-10 top-0 h-40 w-40 rounded-full bg-white/10 blur-3xl" />
        <div className="absolute bottom-0 left-1/3 h-24 w-24 rounded-full bg-pink-400/20 blur-2xl" />

        <div className="relative z-10 flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
          {/* Left Content */}
          <div>


            <div className="relative z-10">
        <h1 className="text-3xl font-bold">Transport</h1>

        <p className="mt-1 text-sm text-purple-100">
          Casagrand International Group of Schools
          <span className="mx-2">|</span>
          Academic Year 2025-26
        </p>
      </div>

          </div>

          {/* Right Actions */}
          <div className="flex flex-wrap items-center gap-3">
           {/* Date */}
<button className="flex items-center justify-center gap-2 w-38 rounded-lg border border-white/20 bg-white/10 px-4 py-2 text-sm font-medium backdrop-blur transition hover:bg-white/20">
  <CalendarDays size={18} />
  <span className="text-base">{currentMonth}</span>
</button>

{/* Export */}
{/*
<button className="flex items-start justify-center gap-2 w-38 rounded-lg border border-white/20 bg-white/10 px-4 py-2 text-sm font-medium backdrop-blur transition hover:bg-white/20">
  <Download size={30} className="inline-block align-top" />
  <span className="inline-block align-top text-base">Export</span>
</button>*/}

{/* Edit */}
<Link data-html2canvas-ignore="true" to={"/edit/transport"} className="flex items-center justify-center gap-2 w-38 rounded-lg bg-white px-4 py-2 text-sm font-semibold text-purple-700 transition hover:bg-purple-50">
  <SquarePen size={18} />
  <span className="text-base">Edit</span>
</Link>

          </div>
        </div>
      </div>
    </div>
  );
};

export default OverviewHeader;
